import { render, staticRenderFns } from "./EquipeConsultor.vue?vue&type=template&id=4720a1ee&"
import script from "./EquipeConsultor.vue?vue&type=script&lang=js&"
export * from "./EquipeConsultor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports